export default __webpack_public_path__ + "static/secure-illustration-311d1dd63cadf1c77153550c163c4f12.svg";